package com.nonopn.skydome.common.app.pages.main.model.api

import com.nonopn.skywatcher.maps.LatLng
import kotlinx.serialization.Serializable

@Serializable
data class Project(
    val latitude: Double,
    val longitude: Double,
    val name: String,
    val uuid: String,
    // Creation date in milliseconds UTC (null on older backends)
    val createdAt: Long? = null,
) {
    val coordinates: LatLng = LatLng(latitude, longitude)
}
